import React from 'react';
import ClientFollowupPage from './ClientFollowupPage';

const ReturnFollowup = () => (
  <ClientFollowupPage
    title="Return Followup"
    endpoint="ClientReturnClientFollowup"
    parentKey="ClientReturn"
    amountLabel="Amount"
    amountKey=""
  />
);

export default ReturnFollowup;
